module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "step1"
  }, [_vm._v("Step I")]), _vm._v(" "), _c('p', {
    staticClass: "step"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }), _c('b', [_vm._v("LAY A SOLID STRATEGIC FOUNDATION")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many coaches start promoting their services before they have really thought through key strategic questions. By ignoring or avoiding these questions, they fail to set themselves apart when they try to develop business. As a result, prospects don’t have a compelling reason to hire them, and they lose business to coaches who do have a clear strategy. A good strategic foundation includes: a profitable target market that you can dominate; an understanding of the market’s needs; a solution that gets clear results and provides great value; and a marketing message that compels them to contact you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd7aac62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/step1.vue
// module id = 87
// module chunks = 0